import React from 'react';

function Header() {
    return <div class="header"> <p class="headerText">Looper Hooper - for music creators</p></div>
}

export default Header;
